import React from "react";
import { Reveal } from "./Reveal";
import { BoxIcon } from "lucide-react";
type SectionHeadingProps = {
  label: string;
  icon: BoxIcon;
  title: React.ReactNode;
  align?: 'left' | 'center';
};
export function SectionHeading({
  label,
  icon: Icon,
  title,
  align = 'center'
}: SectionHeadingProps) {
  const isCentered = align === 'center';
  return <Reveal className={isCentered ? 'flex flex-col items-center text-center' : 'flex flex-col items-start text-left'} data-id="element-270" data-mp="3k29jy6e1o6za">
      <span className="inline-flex items-center gap-2 rounded-full border border-gold-400/35 bg-gold-400/[0.07] px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold-300" data-id="element-271" data-mp="gjgk0we6vgnl">
        <Icon className="h-3.5 w-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-272" data-mp="1spr1l0v2biw" />
        {label}
      </span>
      <h2 className={`mt-4 max-w-3xl text-balance text-[22px] font-extrabold leading-[1.15] tracking-tight text-[#f5f3ee] sm:mt-5 sm:text-3xl md:text-[2.6rem] ${isCentered ? 'mx-auto' : ''}`} data-id="element-273" data-mp="uj7u4m1l4cwb">
        {title}
      </h2>
      <span className={`mt-4 block h-px w-24 bg-gradient-to-r from-transparent via-gold-400/70 to-transparent sm:mt-6 ${isCentered ? 'mx-auto' : ''}`} data-id="element-274" data-mp="1t9fsp9x29ckt" />
    </Reveal>;
}